import React, { useState, useEffect } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

function SkeletonTaskCard() {
    const [baseColor, setBaseColor] = useState("#202020");
    const [highlightColor, setHighlightColor] = useState("#444");

    useEffect(() => {
      const color = getComputedStyle(document.documentElement).getPropertyValue('--main-color-hover-').trim();
      const highlightColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color-hover-hover-').trim();
      setBaseColor(color);
      setHighlightColor(highlightColor);
    }, []);

  return (
    <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor} >
    <div className='TaskCard-frame'>
      <div className="TaskCard">
        <div className="TaskCard-content">
          <h2><Skeleton /></h2>
          <p className="assignTo"><Skeleton /></p>
          <h2><Skeleton /></h2>
          <p className='client-name'><Skeleton /></p>
          <ul>
            <li className='step h-20px'><Skeleton /></li>
            <li className='step h-20px'><Skeleton /></li>
            <li className='step h-20px'><Skeleton /></li>
          </ul>
        </div>
        <div className="progress-bar">
          <div className="progress-bar__completed">
          </div>
        </div>
        <p className='progress-pourcentage'><Skeleton /></p>
        <p className='task-status'>Statue : <Skeleton /></p>
      </div>
      <div className="btn-container">
        <button className='btn-supprimer'><Skeleton /></button>
        <Skeleton />
      </div>
    </div>
    </SkeletonTheme>
  );
}

export default SkeletonTaskCard;
